import {
  Alert,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { terminateAccount } from '../../modules/users';
import ConfirmationModal from '../elements/ConfirmationModal';
import { useUser } from '../../context/UserContext';

const DeleteAccount = ({ user }) => {
  const { clearUserData } = useUser();
  const [openModal, setOpenModal] = useState(false);
  const [type, setType] = useState('confirm');
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleContinue = async () => {
    try {
      const response = await terminateAccount(user.organization_id);
      if (response) {
        setType('confirmed');
        setTimeout(async () => {
          // await signOut();
          clearUserData();
          navigate('/login', { replace: true });
        }, 2000);
      }
    } catch (err) {
      setError(err.message);
    }
  };

  const handleClose = () => {
    setOpenModal(false);
    setError(null);
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = '';
    };
    if (type === 'confirmed') {
      window.addEventListener('beforeunload', handleBeforeUnload);
    }
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [type]);

  return (
    <Card sx={{ mt: 2 }}>
      <CardContent>
        <Grid container spacing={2}>
          <>
            <Grid item xs={8}>
              <Typography variant="h5" sx={{ mb: 2 }}>
                Request Permanent Account Deletion
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Permanently remove your organization account and all associated
                data from GAINSS.
              </Typography>
            </Grid>
            <Grid
              item
              xs={4}
              container
              justifyContent="flex-end"
              alignItems="center">
              <Button variant="text" color="error" onClick={handleOpenModal}>
                Permanently Delete Account
              </Button>
            </Grid>
          </>
        </Grid>
      </CardContent>
      <ConfirmationModal
        show={openModal}
        width='md'
        hideButton={type === 'confirmed' || error ? true : false}
        handleClose={type === 'confirm' ? handleClose : null}
        handleConfirm={handleContinue}
        title="Confirm Account Deletion"
        body={
          <>
            {type === 'confirm' ? (
              <>
                <p>
                  <strong>Before proceeding, please note:</strong>
                </p>
                <ul>
                  <li>
                    All data associated with your organization, including
                    projects, test cases, and test cycles, will be permanently
                    deleted.
                  </li>
                  <li>
                    Attachments, comments, linked issues, and executions will be
                    irreversibly erased.
                  </li>
                  <li>
                    Your organization's details, including all personal and team
                    data, will no longer be accessible.
                  </li>
                  <li>
                    <em>
                      Once you request account deletion, your team will no
                      longer be able to sign in to <strong>GAINSS</strong>.
                    </em>
                  </li>
                </ul>

                <p className="text-danger">
                  If you wish to cancel your deletion request, you have{' '}
                  <strong>21 days</strong> from the date of submission to do so.
                  After this period, your data will be permanently removed.
                </p>
                <p>
                  If you have any questions or need assistance, please contact
                  our <strong>support team</strong>.
                </p>
              </>
            ) : (
              <>
                <p>
                  Thank you for being a part of <strong>GAINSS</strong>. We
                  appreciate your time with us and hope our platform has been
                  valuable to you.
                </p>
                <p>
                  If you have any feedback or require assistance, our support
                  team is available to help. Should you reconsider your
                  decision, please contact us as soon as possible.
                </p>
                <p className="text-danger text-center">
                  You will be automatically signed out.
                </p>
              </>
            )}
            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}
          </>
        }
      />
    </Card>
  );
};

export default DeleteAccount;
